import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SingleError from '../../helper/SingleError';
import { UserValidateFields } from '../validate/userValidation';
import ErrorFilter from '../../helper/errorFilter';
import { toast } from 'react-toastify';
import { requestHandler } from '../../helper';
import { userPasswordChange } from '../../controller';

function UserChangePassword({ id, getAllUsers }) {

    const [show, setShow] = useState(false);
    const [errors, setErrors] = useState({});
    const [submitCount, setSubmitCount] = useState(0);
    const [userId, setUserId] = useState(null);

    const requireField = [
        "password",
        "confirmPassword",
    ];

    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: '',
    })

    const handleClose = () => setShow(false);
    const handleShow = (id) => {
        setShow(true);
        setUserId(id);
    }

    const [showPassword, setShowPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState(false);

    const togglePasswordVisibility1 = () => {
        setShowPassword(!showPassword);
    };
    const togglePasswordVisibility2 = () => {
        setConfirmPassword(!confirmPassword);
    };

    const handleChange = async (e) => {
        const { name, value, checked, type } = e.target;
        let newValue = type === "checkbox" ? checked : value;
        if (submitCount > 0) {
            let validationErrors = UserValidateFields({ ...formData, [name]: value });
            validationErrors = ErrorFilter(validationErrors, requireField);
            setErrors(validationErrors);
            if (Object.keys(validationErrors).length === 0) {
                delete errors[name];
            }
        }
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }


    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...formData };

        let validationErrors = UserValidateFields(updatedValues);
        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            delete updatedValues.confirmPassword;
            await requestHandler(
                async () => await userPasswordChange(updatedValues, userId),
                null,
                (res) => {
                    toast.success(res.message);
                    handleClose();
                    setFormData({
                        password: '',
                        confirmPassword: '',
                    });
                    getAllUsers();
                },
                () => { }
            )

        }

    }

    return (
        <>
            {/* <div className='d-flex align-items-center gap-2'  onClick={handleShow}>
                <img src="../images/png/my_profile.png" width={34.47} height={34.47} alt="" />
                Password
            </div> */}
            <OverlayTrigger
                key="tooltip"
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>Password</Tooltip>}
            >
                <button className='border-0' onClick={() => handleShow(id)}>
                    <img src="../images/png/lock.png" alt="" />
                </button>
            </OverlayTrigger>


            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Change Password</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <Form>
                            <Form.Group className="mb-3" controlId="formGroupPassword1">
                                <Form.Label>New Password</Form.Label>
                                <div className='form-control d-flex align-items-center ps-0 py-0'>
                                    <Form.Control
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter New Password"
                                        className='input-border-0'
                                        value={formData.password}
                                        onChange={handleChange}
                                        name='password'
                                    />
                                    <img
                                        width={22}
                                        src={showPassword ? "../images/png/show-eye.png" : "../images/png/close-eye.png"}
                                        alt=""
                                        style={{ cursor: 'pointer' }}
                                        onClick={togglePasswordVisibility1}
                                    />
                                </div>
                                <SingleError error={errors?.password} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupPassword2">
                                <Form.Label>Confirm Password</Form.Label>
                                <div className='form-control d-flex align-items-center ps-0 py-0'>
                                    <Form.Control
                                        type={confirmPassword ? 'text' : 'password'}
                                        placeholder="Enter Confirm Password"
                                        className='input-border-0'
                                        name='confirmPassword'
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                    />
                                    <img
                                        width={22}
                                        src={confirmPassword ? "../images/png/show-eye.png" : "../images/png/close-eye.png"}
                                        alt=""
                                        style={{ cursor: 'pointer' }}
                                        onClick={togglePasswordVisibility2}
                                    />
                                </div>
                                <SingleError error={errors?.confirmPassword} />
                            </Form.Group>
                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button' onHide={handleClose}>Cancel</button>
                                <button className='save-btn' type='button' onClick={handleSubmit}>Save</button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UserChangePassword